// Das eigene Profil, oben rechts — auf jedem Bildschirm an derselben Stelle.
//
// Warum oben rechts und nicht im Menü: Dort sucht man es. Jede App der letzten
// zehn Jahre legt das Konto dorthin, und der Weg zu Passwort, Arbeitszeiten und
// Abmelden darf nicht davon abhängen, ob jemand die Seitenleiste kennt — die es
// für Fahrer ohnehin nicht mehr gibt.
//
// Der Knopf zeigt das Profilbild. Ohne Bild den Anfangsbuchstaben: Bei sieben
// Leuten unterscheidet der sofort, ein graues Männchen nie.

import { Link, useLocation } from "react-router-dom";
import { useMeinProfil } from "@/lib/profil";
import { useAuth } from "@/stores/authStore";
import { cn } from "@/design-system/ui";

export function ProfilKnopf({ className }: { className?: string }) {
  const { data: profil } = useMeinProfil();
  const session = useAuth((s) => s.session);
  const { pathname } = useLocation();

  const mail = session?.user.email ?? "";
  const name =
    profil?.full_name ??
    (session?.user.user_metadata as { full_name?: string } | undefined)?.full_name ??
    "";
  const buchstabe = (name || mail || "?").slice(0, 1).toUpperCase();
  const aktiv = pathname.startsWith("/crm/profil");

  return (
    <Link
      to="/crm/profil"
      aria-label={`Profil von ${name || mail}`}
      data-testid="profil-knopf"
      className={cn(
        // 44 px Trefferfläche — das Bild darin ist kleiner, das Ziel nicht.
        "grid h-11 w-11 shrink-0 place-items-center rounded-full",
        "transition-colors duration-fast",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gruen-500/60",
        className
      )}
    >
      <span
        className={cn(
          "grid h-9 w-9 place-items-center overflow-hidden rounded-full",
          "text-sm font-semibold",
          aktiv
            ? "bg-gruen-500 text-gruen-on ring-2 ring-gruen-400"
            : "bg-ink-700 text-ink-100 ring-1 ring-ink-600"
        )}
      >
        {profil?.avatar_url ? (
          <img
            src={profil.avatar_url}
            alt=""
            className="h-full w-full object-cover"
            // Bricht das Bild (gelöschte Datei, kein Netz), soll der Buchstabe
            // erscheinen — nicht ein kaputtes Bild-Symbol.
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).style.display = "none";
            }}
          />
        ) : (
          buchstabe
        )}
      </span>
    </Link>
  );
}
